import Vue from 'vue'
import Router from 'vue-router'
import {
  routerMode
} from '@/config/env'
import store from '@/config/store'
Vue.use(Router)
//路由配置
const routes = [{
    path: '/',
    name: 'index',
    component: resolve => require(['@/page/index.vue'], resolve)
  },
  {
    path: '/cases',
    name: 'cases',
    component: resolve => require(['@/page/cases.vue'], resolve)
  },
  {
    path: '/casesDetails/:index',
    name: 'casesDetails',
    component: resolve => require(['@/page/casesDetails.vue'], resolve)
  },
  {
    path: '/news',
    name: 'news',
    component: resolve => require(['@/page/news.vue'], resolve)
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: resolve => require(['@/page/contactUs.vue'], resolve)
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: resolve => require(['@/page/aboutUs.vue'], resolve)
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: resolve => require(['@/page/newsDetails.vue'], resolve)
  },
  {
    path: '/template',
    name: 'template',
    component: resolve => require(['@/page/template.vue'], resolve)
  },
  {
    path: '/templateDetails/:index',
    name: 'templateDetails',
    component: resolve => require(['@/page/templateDetails.vue'], resolve)
  },
  {
    path: '/upload',
    name: 'upload',
    component: resolve => require(['@/page/upload.vue'], resolve)
  },
];
let router = new Router({
  //模式
  mode: routerMode,
  //代码检查
  // strict: process.env.NODE_ENV !== 'production',
  //页面滚动
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  },
  routes,
  "router-link-active": "active",
  "linkExactActiveClass": "active",
});
//页面加载时
router.beforeEach(function (to, from, next) {
  store.commit('setLoading', true);
  if (/\/http/.test(to.path)) {
    let url = to.path.split('http')[1]
    window.location.href = `http${url}`
  } else {
    next();
  }
});
//页面销毁时
router.afterEach(function () {
  store.commit('setLoading', false);
});
export default router;
